import React from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import { Auth0Provider, ErrorHandlerProvider } from '@ondeck/silkworm';
import { IntlProvider } from 'react-intl';
import AppContent from 'components/AppContent';
import { AppDataProvider } from 'contexts/appContext';
import PageRouter from './PageRouter';
import { locale, messages } from './locales';
import { useTracking } from 'react-tracking';
import { Analytics } from './analytics';

declare const window: any;

const trackEvents = window.env.REACT_APP_MIXPANEL_TRACK_EVENTS == "true";

const App = () => {
  const { Track } = useTracking(
    { application: 'Partner Offer' },
    {
      dispatch: (data: any) => {
        trackEvents && Analytics.track(data);
      }
    }
  );

  return (
    <Track>
      <IntlProvider locale={locale} messages={messages[locale]}>
        <ErrorHandlerProvider>
          <Auth0Provider
            domain={window.env.REACT_APP_AUTH0_DOMAIN}
            audience={window.env.REACT_APP_AUTH0_AUDIENCE}
            clientID={window.env.REACT_APP_AUTH0_CLIENT_ID}
            connection={window.env.REACT_APP_AUTH0_CONNECTION}
            redirectUri={window.env.REACT_APP_AUTH0_REDIRECT_URI}
            responseType="code"
            scope="profile"
          >
            <AppDataProvider>
              <BrowserRouter>
                <Switch>
                  <AppContent>
                    <Switch>
                      <PageRouter />
                    </Switch>
                  </AppContent>
                </Switch>
              </BrowserRouter>
            </AppDataProvider>
          </Auth0Provider>
        </ErrorHandlerProvider>
      </IntlProvider>
    </Track>
  );
};

export default App;
